import type { trackEcommerce } from '@svenskaspelab/nova-core/nextjs/analytics';
import type { DialogConfig } from '@svenskaspelab/nova-foundation/nextjs/dialog';
import type { ReactNode } from 'react';

import type { Product } from '../../../../schema/product/entry.js';
import type { WagerId } from '../../../../schema/wager/entry.js';
import { type IRemoveWagerUseCase } from '../../../domain/entry.js';

export type IRemoveWagerController = ReturnType<typeof removeWagerController>;

type ControllerArg = {
  product: Product;
  price: number;
  wagerId: WagerId;
  isMarketplace?: boolean;
  showDialog: (props: DialogConfig, meta?: string[]) => Promise<void>;
  callbackOnDone?: () => void;
  trackTransaction?: typeof trackEcommerce;
  icon?: ReactNode;
};

/**
 * Controller to remove a wager.
 *
 * @param removeWagerUseCase Use case to remove a wager
 * @returns Controller function that removes a wager
 */
export function removeWagerController(removeWagerUseCase: IRemoveWagerUseCase) {
  return async function controller({
    product,
    price,
    wagerId,
    isMarketplace,
    showDialog,
    callbackOnDone,
    trackTransaction,
    icon,
  }: ControllerArg): Promise<void> {
    await removeWagerUseCase.execute({
      product,
      price,
      wagerId,
      isMarketplace,
      showDialog,
      callbackOnDone,
      trackTransaction,
      icon,
    });
  };
}
